import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Stack, Typography } from "@mui/material";

/* Display message that all devices are paired*/
const AllPaired = () => (
  <Stack sx={{ alignItems: 'center', justifyContent: 'center' }}>
    <Typography sx={{ color: 'success.main' }}>
      <CheckCircleIcon fontSize="large" />
    </Typography>
    <Typography>
      All devices are paired.
    </Typography>
  </Stack>
);

export default AllPaired;